module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'S’abonner aux textos de Sephora',
        continueShopping: 'Continuer à magasiner',
        heading: 'Nous y sommes presque. Un message texte\nest en route. Répondez O pour confirmer.',
        checkYourSMS: `Vérifiez votre boîte de réception SMS à ${vars[0]} \nRépondez O pour vous abonner et recevoir votre code de réduction de 10 %.`,
        disclaimerLine1: `En entrant votre numéro de téléphone, en cliquant sur soumettre et en confirmant votre inscription, vous consentez à ${vars[0]} et à recevoir des messages textes de marketing automatiques récurrents. La fréquence des messages varie. Le consentement n’est pas une condition d’achat. Des frais de messagerie texte et de données peuvent s’appliquer. Consultez notre ${vars[1]}. Textez ARRET pour annuler en tout temps. AIDE pour obtenir de l’aide.`,
        textTerms: 'modalités des messages texte',
        privacyPolicy: 'Politique de confidentialité'
    };

    return resources[label];
};
